import {
  PublicHeader,
  Breadcrumb,
  SelectAnoEmendas,
  ValorDestaqueHeader
} from '../../../components'
import { mapState } from 'vuex'
import { formatarMoeda } from '@/utils'
import { mapGetters } from 'vuex/dist/vuex.common.js'

export default {
  components: {
    PublicHeader,
    Breadcrumb,
    SelectAnoEmendas,
    ValorDestaqueHeader
  },
  data() {
    return {
      breadcrumb: [
        {
          label: 'Emendas Parlamentares'
        }
      ]
    }
  },
  methods: {
    formatarMoeda
  },
  computed: {
    ...mapState({
      emendas: state => state.emendas_parlamentares.emendas,
      loading: state => state.emendas_parlamentares.loading
    }),
    ...mapGetters([
      'quantidadeEmendas',
      'valorTotalEmendas',
      'quantidadeVereadores',
      'saldoTotal',
      'valorTotalUtilizado'
    ])
  }
}



// WEBPACK FOOTER //
// ./src/views/public/emendas_parlamentares/emendas.js